import { useMutation, useQueryClient } from '@tanstack/react-query';
import { verlofApi } from '../../../lib/verlofApi';
import { leaveKeys } from './useMijnVerlof';

/** Story 1.4: withdraw an own leave request. Invalidates the own-overview cache on success. */
export function useWithdrawLeaveRequest() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => verlofApi.withdraw(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: leaveKeys.mine() });
    },
  });
}
